module.exports = __webpack_public_path__ + "static/media/001.76f5ac54.jpg";